import 'babel-polyfill'
// vue.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import App from './App'
import VueForm from './components/Form'
import NotFoundError from './components/404'
import VueLogin from './components/VueLogin.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import ResetPassword from './components/ResetPassword.vue'
// Public Layout
import PublicLayout from './components/public/Layout'
// Dashboard
import PublicDashboard from './components/public/Dashboard'
// Payment
import Billing from './components/public/Billing'
// Reservation
import Reservation from './components/public/Reservation'
import MyReservations from './components/public/MyReservations'
import ViewReservation from './components/public/ViewReservation'
import CarReservationDetails from './components/displays/CarReservationDetails'
import BookingConfirmation from './components/BookingConfirmation'
import BulkChargeDisplay from './components/displays/BulkChargeDisplay'
import HeldChargeDisplay from './components/displays/HeldChargeDisplay'
// Rates / Landing
import RatesDisplay from './components/public/RatesDisplay'
import WhyGSC from './components/public/WhyGSC'
import AccountLimitError from './components/public/AccountLimitError'
// Account
import MyAccount from './components/MyAccount'
// misc
import moment from 'moment-timezone'
// Reports
import Report from './components/public/Report'

Vue.use(VueResource)
Vue.use(VueRouter)

Vue.filter('date_format', {
  // model -> view
  read: function (val, timezone) {
    if (timezone) {
      return moment(val).tz(timezone).format('ddd, MMM Do YYYY, h:mma')
    } else {
      return moment(val).format('ddd, MMM Do YYYY, h:mma Z')
    }
  },
  // view -> model
  write: function (val, oldVal) {
    if (moment(val, 'ddd, MMM Do YYYY, h:mma').isValid()) {
      return moment(val, 'ddd, MMM Do YYYY, h:mma').toDate()
    } else {
      return moment(val, 'ddd, MMM Do YYYY, h:mma Z').toDate()
    }
  }
})
Vue.filter('time_format', {
  // model -> view
  read: function (val) {
    if (!val) return 'No Time Set'
    return moment(val).tz('Australia/Melbourne').format('h:mm a')
  },
  // view -> model
  write: function (val, oldVal) {
    return moment(val, 'h:mm a').tz('Australia/Melbourne').toDate()
  }
})
Vue.filter('short_date_format', {
  // model -> view
  read: function (val) {
    if (!val) return 'No Date Set'
    return moment(val).tz('Australia/Melbourne').format('DD/MM/YYYY')
  },
  // view -> model
  write: function (val, oldVal) {
    return moment(val, 'DD/MM/YYYY').tz('Australia/Melbourne').toDate()
  }
})
Vue.filter('currency_round', {
  // model -> view
  read: function (val) {
    if (!val || val < 0) return '$0'
    return '$' + Number(Math.round(val + 'e2') + 'e-2').toFixed(2)
  },
  // view -> model
  write: function (val, oldVal) {
    return val
  }
})
Vue.filter('currency_round_abs', {
  // model -> view
  read: function (val) {
    return '$' + Number(Math.round(Math.abs(val) + 'e2') + 'e-2').toFixed(2)
  },
  // view -> model
  write: function (val, oldVal) {
    return val
  }
})
Vue.filter('currency_round_neg', {
  // model -> view
  read: function (val) {
    if (!val) return '$0'
    else if (val < 0) return '-$' + Number(Math.round(Math.abs(val) + 'e2') + 'e-2').toFixed(2)
    else return '$' + Number(Math.round(val + 'e2') + 'e-2').toFixed(2)
  },
  // view -> model
  write: function (val, oldVal) {
    return val
  }
})
Vue.filter('currency_short', {
  // model -> view
  read: function (val) {
    if (!val || val < 0) return '$0'
    return Number(Math.round(val + 'e2') + 'e-2').toFixed(0)
  },
  // view -> model
  write: function (val, oldVal) {
    return val
  }
})
Vue.filter('stripe_currency', {
  // model -> view
  read: function (val) {
    if (!val || val < 0) return '$0'
    return '$' + (Number(Math.round(val + 'e2') + 'e-2') / 100).toFixed(2)
  },
  // view -> model
  write: function (val, oldVal) {
    return val
  }
})
Vue.filter('to_calendar_time', {
  // model -> view
  read: function (val) {
    let xm = 'AM'
    if (val >= 12) {
      val = val - 12
      xm = 'PM'
      if (val >= 24) xm = 'AM'
    }
    if (val === 0) val = 12
    return `${val}${xm}`
  },
  // view -> model
  write: function (val, oldVal) {
    return val
  }
})

let router = new VueRouter({
  linkActiveClass: 'active',
  hashbang: false,
  history: true
})

Vue.config.debug = process.env.NODE_ENV === 'development'
Vue.config.silent = process.env.NODE_ENV === 'production'

// Vue HTTP options
Vue.http.options.root = '/api'
Vue.http.interceptors.push((request, next) => {
  let loadingDiv = document.createElement('div')
  let spinnerDiv = document.createElement('div')
  loadingDiv.id = 'loadingDiv'
  spinnerDiv.className = 'spinner-div'
  loadingDiv.className = 'loading'
  let exists = document.getElementById('loadingDiv')
  if (!exists) {
    document.body.appendChild(loadingDiv)
    loadingDiv.appendChild(spinnerDiv)
    loadingDiv.setAttribute('data-requests', 1)
    loadingDiv.setAttribute('data-responses', 0)
  } else {
    let count = parseInt(exists.getAttribute('data-requests'))
    exists.setAttribute('data-requests', count + 1)
  }
  next((response) => {
    var loadingDivRemove = document.getElementById('loadingDiv')
    if (loadingDivRemove) {
      let count = parseInt(loadingDivRemove.getAttribute('data-responses'))
      loadingDivRemove.setAttribute('data-responses', count + 1)
      let requests = parseInt(loadingDivRemove.getAttribute('data-requests'))
      let responses = parseInt(loadingDivRemove.getAttribute('data-responses'))
      if (requests === responses) {
        loadingDivRemove.parentNode.removeChild(loadingDivRemove)
      }
    }
    try {
      response.data = JSON.parse(response.data)
    } catch (e) {
      response.data = response.data
    }
    return response
  })
})

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (response instanceof Error) {
      console.log(response)
    }
    if (response.status === 401) {
      router.app.$set('fromPath', router.app.$root.$route.fullPath)
      if (router.app.$root.$route.authType === 'admin') {
        router.go('/admin/login')
      } else {
        router.go('/')
      }
    } else if (response.status === 404) {
      router.go('/')
    }
    return response
  })
})
router.beforeEach(function (transition) {
  if ($('.modal').modal) { $('.modal').modal('hide') }
  if (router.app.$route.query && router.app.$route.query.token) {
    window.sessionStorage.setItem('token', router.app.$route.query.token)
  }
  if (window.sessionStorage.getItem('token')) {
    router.app.$set('fromPath', false)
    Vue.http.headers.common.Authorization = 'Bearer ' + window.sessionStorage.getItem('token')
    transition.next()
  } else if (transition.to.authType === 'admin' && transition.to.path !== '/admin/login') {
    router.app.$set('fromPath', transition.to.path)
    transition.redirect('/admin/login')
  } else if (transition.to.authType === 'private' && !transition.to.loginPage) {
    router.app.$set('fromPath', transition.to.path)
    transition.redirect('/')
  } else {
    transition.next()
  }
})
router.map({
  '/': {
    component: PublicLayout,
    authType: 'public',
    subRoutes: {
      '/': {
        component: VueLogin,
        authType: 'public',
        loginPage: true,
        noFooter: true,
        subRoutes: {
          '/': {
            component: VueForm,
            vueForm: 'login',
            vueFormMethod: 'post'
          },
          '/login': {
            component: VueForm,
            vueForm: 'login',
            vueFormMethod: 'post'
          },
          '/maintenance': {
            component: VueForm,
            vueForm: 'maintenanceLogin',
            vueFormMethod: 'post'
          }
        }
      },
      '/dashboard': {
        component: PublicDashboard,
        authType: 'private'
      },
      '/sign-up': {
        component: RatesDisplay,
        loginPage: true,
        noFooter: true,
        ratesPage: true
      },
      '/why-gsc': {
        component: WhyGSC,
        loginPage: true,
        noFooter: true,
        ratesPage: true
      },
      '/forgot-password': {
        component: ForgotPassword,
        loginPage: true,
        ratesPage: true
      },
      '/reset-password/:resetToken': {
        component: ResetPassword,
        loginPage: true,
        ratesPage: true
      },
      '/account-limit-reached': {
        component: AccountLimitError,
        loginPage: true,
        ratesPage: true
      },
      '/sign-up/register': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register' }],
        component: VueForm,
        vueForm: 'register',
        vueFormMethod: 'post',
        noFooter: true,
        loginPage: true
      },
      '/sign-up/register/edit': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register/edit' }],
        component: VueForm,
        vueForm: 'registerEdit',
        vueFormMethod: 'post',
        loginPage: true
      },
      '/sign-up/register/:accountType': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register' }],
        component: VueForm,
        vueForm: 'register',
        vueFormMethod: 'post',
        noFooter: true,
        loginPage: true
      },
      '/sign-up/register/contact-details': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register/edit' }, { name: 'Contact Details', url: '/sign-up/register/contact-details' }],
        component: VueForm,
        vueForm: 'registerContactDetails',
        vueFormMethod: 'post',
        noFooter: true,
        loginPage: true
      },
      '/sign-up/register/contact-details/edit': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register/edit' }, { name: 'Contact Details', url: '/sign-up/register/contact-details' }],
        component: VueForm,
        vueForm: 'registerContactDetailsEdit',
        vueFormMethod: 'post',
        noFooter: true,
        loginPage: true
      },
      '/sign-up/register/driver-history': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register/edit' }, { name: 'Contact Details', url: '/sign-up/register/contact-details/edit' }, { name: 'Verifiction', url: '/sign-up/register/driver-history' }],
        component: VueForm,
        vueForm: 'registerDriverHistory',
        vueFormMethod: 'post',
        loginPage: true
      },
      '/sign-up/register/driver-history/edit': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register/edit' }, { name: 'Contact Details', url: '/sign-up/register/contact-details/edit' }, { name: 'Verifiction', url: '/sign-up/register/driver-history' }],
        component: VueForm,
        vueForm: 'registerDriverHistoryEdit',
        vueFormMethod: 'post',
        noFooter: true,
        loginPage: true
      },
      '/sign-up/register/verification/': {
        breadcrumbs: [{ name: 'Register', url: '/sign-up/register/edit' }, { name: 'Contact Details', url: '/sign-up/register/contact-details/edit' }, { name: 'Verifiction', url: '/sign-up/register/driver-history/edit' }, { name: 'Complete', url: '/sign-up/register/verification' }],
        component: VueForm,
        vueForm: 'registerVerify',
        vueFormMethod: 'post',
        noFooter: true,
        loginPage: true
      },
      '/reserve': {
        component: Reservation,
        authType: 'private'
      },
      '/reserve/confirm/:reservationId': {
        component: BookingConfirmation,
        authType: 'private'
      },
      '/reserve/car/:carId': {
        component: CarReservationDetails,
        authType: 'private'
      },
      '/my-reservations': {
        component: MyReservations,
        authType: 'private'
      },
      '/reservation/:reservationId': {
        component: ViewReservation,
        authType: 'private'
      },
      '/charge/:chargeId': {
        component: BulkChargeDisplay,
        authType: 'private'
      },
      '/preauth/:chargeId': {
        component: HeldChargeDisplay,
        authType: 'private'
      },
      '/my-account': {
        component: MyAccount,
        authType: 'private'
      },
      '/billing': {
        component: Billing,
        authType: 'private'
      },
      '/contact': {
        component: VueForm,
        vueForm: 'contact',
        vueFormMethod: 'put',
        authType: 'private'
      },
      '/report': {
        component: Report,
        authType: 'private'
      },
      '/report/:carId': {
        component: Report,
        authType: 'private'
      },
      '/report/damage/:carId': {
        component: VueForm,
        vueForm: 'reportDamage',
        vueFormMethod: 'put',
        authType: 'private'
      },
      '/report/clean/:carId': {
        component: VueForm,
        vueForm: 'requestClean',
        vueFormMethod: 'put',
        authType: 'private'
      },
      '/report/lowfuel/:carId': {
        component: VueForm,
        vueForm: 'reportLowFuel',
        vueFormMethod: 'put',
        authType: 'private'
      },
      '/report/spacetaken/:carId': {
        component: VueForm,
        vueForm: 'carSpaceTaken',
        vueFormMethod: 'put',
        authType: 'private'
      },
      '/report/car-not-there/:carId': {
        component: VueForm,
        vueForm: 'carNotThere',
        vueFormMethod: 'put',
        authType: 'private'
      },
      '*': {
        component: NotFoundError,
        public: true
      }
    },
    '*': {
      component: NotFoundError,
      name: 'notfound',
      public: true
    }
  },
  '*': {
    component: NotFoundError,
    public: true
  }
})
router.start(App, '#app')



// WEBPACK FOOTER //
// ./src/main.js